import { useEffect, useRef, useState } from 'react';
import { Check, Copy } from 'lucide-react';

/** Copies a payload and flips to a tick briefly; a clipboard refusal leaves the icon unchanged. */
export const CopyButton = ({ text, label }: { text: string; label: string }) => {
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef<ReturnType<typeof setTimeout>>(undefined);
  useEffect(() => () => clearTimeout(resetTimer.current), []);

  return (
    <button
      type='button'
      className='inline-flex cursor-pointer items-center text-gray-800 transition-colors hover:text-text-heading'
      aria-label={`Copy ${label}`}
      title={`Copy ${label}`}
      onClick={() => {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            setCopied(true);
            clearTimeout(resetTimer.current);
            resetTimer.current = setTimeout(() => setCopied(false), 1500);
          })
          .catch(() => undefined);
      }}
    >
      {copied ? <Check className='size-3 text-green-600' /> : <Copy className='size-3' />}
    </button>
  );
};
